<template>
  <div>
    <h2 class="text-center">{{ chart.titulo }}</h2>
    <h3 v-if="false" class="text-center">({{ chart.tipo }})</h3>
    <FiltrosParams
      :filters="chart.params"
      v-model="filter"
      @change="changeFilter"
      :preFiltros="preFiltros"
    />

    <template v-if="!data">
      <div class="w-100 d-flex justify-content-center align-items-center h70vh">
        <div class="sk-flow">
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
          <div class="sk-flow-dot bg-primary"></div>
        </div>
      </div>
    </template>
    <template v-else>
      <ComplexIndicatorWrap
        v-if="chart.tipo === 'indicador-complejo-wrap'"
        :data="data"
        :estructura="chart.estructura"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty @click="_ => fetchData(globalFilter, 'chart=>Empty')" />
        </template>
      </ComplexIndicatorWrap>

      <Table
        v-else-if="chart.tipo === 'table'"
        :data="data"
        :estructura="chart.estructura"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty @click="_ => fetchData(globalFilter, 'chart=>Empty')" />
        </template>
      </Table>
      <Pie2
        v-else-if="chart.tipo === 'pay-2'"
        :data="data"
        :estructura="chart.estructura"
        :moneda="chart.moneda"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty @click="_ => fetchData(globalFilter, 'chart=>Empty')" />
        </template>
      </Pie2>
      <Tree
        v-else-if="chart.tipo === 'tree'"
        :data="data"
        :estructura="chart.estructura"
        :moneda="chart.moneda"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></Tree>
      <CollapseTable
        v-else-if="chart.tipo === 'collapse-table'"
        :data="data"
        :estructura="chart.estructura"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></CollapseTable>
      <LineDate
        v-else-if="chart.tipo === 'line-date'"
        :data="data"
        :moneda="chart.moneda"
        :bezier="chart.bezier"
        :estructura="chart.estructura"
        :withDots="chart.withDots"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></LineDate>
      <DrillDown
        v-else-if="chart.tipo === 'drill-down'"
        :data="data"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></DrillDown>
      <CollapseList
        v-else-if="chart.tipo === 'collapse-list'"
        :data="data"
        :estructura="chart.estructura"
        :suma="chart.suma"
        :moneda="chart.moneda"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></CollapseList>
      <IndicadorNumericoWrap
        v-else-if="chart.tipo === 'indicador-numerico-wrap'"
        :data="data"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></IndicadorNumericoWrap>
      <ListNumericalIndicator
        v-else-if="chart.tipo === 'list-indicador-numerico'"
        :data="data"
        :onRefresh="onRefresh"
        :refreshing="refreshing"
      >
        <template slot="Empty">
          <Empty
            @click="_ => fetchData(globalFilter, 'chart=>Empty')"
          /> </template
      ></ListNumericalIndicator>
      <template v-else>
        {{ Object.keys(chart) }}
        <pre><code>{{chart}}</code></pre>
        <pre><code>{{data}}</code></pre>
      </template>
    </template>
  </div>
</template>

<script>
import {
  CollapseList,
  CollapseTable,
  ComplexIndicatorWrap,
  DrillDown,
  Empty,
  FiltrosParams,
  IndicadorNumericoWrap,
  LineDate,
  ListNumericalIndicator,
  Pie2,
  Table,
  Tree
} from "./chart.js";
export default {
  name: "ChartA",
  components: {
    CollapseList,
    CollapseTable,
    ComplexIndicatorWrap,
    DrillDown,
    Empty,
    FiltrosParams,
    IndicadorNumericoWrap,
    LineDate,
    ListNumericalIndicator,
    Pie2,
    Table,
    Tree
  },
  props: {
    chart: {
      type: Object,
      default: () => ({})
    },
    preFiltros: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      refreshing: false,
      data: null,
      controller: null,
      filter: this.preFiltros || {}
    };
  },
  computed: {
    globalFilter() {
      return {
        ...(this.ubicacionRaiz ? { ubicaciones: [this.ubicacionRaiz] } : {}),
        ...this.filter,
        ...this.preFiltros
      };
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    reporte() {
      return this.$route?.params?.reporte;
    }
  },
  watch: {
    reporte() {
      this.refreshing = false;
      this.data = null;
    },
    preFiltros(nV) {
      const old = this.$store.getters.analyticsFilter;
      this.$store.dispatch("setAnalyticsFilter", { ...old, ...nV });
      console.log({ old, nV });
      //debugger
    }
  },
  destroyed() {
    //debugger;
    this.abort();
  },
  methods: {
    abort() {
      try {
        console.log("intentar abortar");
        this.controller.abort();
      } catch (error) {
        console.log(error);
      }
    },
    changeFilter() {
      console.log("changeFilter");
      this.fetchData(this.globalFilter || {}, "changeFilter");
    },
    setGlobalFilter(filtro) {
      this.filter = filtro;
    },
    fetchData(filtros = {}, from) {
      this.abort();
      this.data = null;
      //debugger;
      console.log(`fetchData:${from}`, JSON.stringify(filtros));
      this.refreshing = true;
      const endpoint = this.chart.endpoint;
      console.log(
        `${this.chart.titulo}kegovc=>fetchData:${this.chart.tipo}_filters`,
        filtros
      );
      //this.setGlobalFilter(filtros);

      console.log(from, {
        url: endpoint.uri,
        ...endpoint.json,
        params: {
          ...filtros
        }
      });
      //debugger
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.$store
        .dispatch("actMethod", {
          url: endpoint.uri,
          ...endpoint.json,
          params: {
            ...filtros
          },
          options: { signal }
        })
        .then(res => {
          //debugger;
          if (res.status !== "success") {
            this.refreshing = false;
            this.data = [];
            return;
          }
          this.data = res.data;
        })
        .catch(err => {
          console.log(err);
          //debugger;
        })
        .finally(() => {
          setTimeout(() => {
            this.refreshing = false;
          }, 500);
        });
    },
    onRefresh(filt) {
      this.fetchData({ ...this.globalFilter, ...filt }, "chart=>onRefresh");
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style lang="scss" scoped>
.h70vh {
  height: 70vh;
}
</style>
